import api from './api';

export const getStats = async () => {
  try {
    const response = await api.get('/reports/stats');
    return response.data;
  } catch (error) {
    console.warn('Stats endpoint not available, using fallback data');
    return {
      totalMembers: 0,
      activeCases: 0,
      totalContributions: 0,
      pendingApprovals: 0,
      monthlyContributions: [],
    };
  }
};

export const getRecentActivity = async (limit = 10) => {
  try {
    const response = await api.get(`/reports/activity?limit=${limit}`);
    return response.data;
  } catch (error) {
    console.warn('Recent activity endpoint not available');
    return [];
  }
};

export const getMemberReport = async () => {
  try {
    const response = await api.get('/reports/members');
    return response.data;
  } catch (error) {
    console.warn('Member report endpoint not available, returning empty array');
    return [];
  }
};

export const getContributionReport = async (params) => {
  try {
    const response = await api.get('/reports/contributions', { params });
    return response.data;
  } catch (error) {
    console.warn('Contribution report endpoint not available, returning empty object');
    return { contributions: [], totalAmount: 0 };
  }
};